// 레이아웃 관련 상수들
const layout = {
  content: {
    maxWidth: {
      desktop: "560px",
      mobile: "100%"
    }
  }
};

export default layout;
